export enum ComplexCaseTypes {
    Complaint = "Complaint",
    ServiceRecovery = "Service Recovery"
  }
 